import i18n from "@i18n";
import IconComponent from "../../../../../cubeComponent/icons";
import { fieldTypeToIconMap } from "./constant.helper";
import "./constants.css";

import { SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_TASK } from "@Helpers";

const { t } = i18n;

export const getSectionFieldItems = () => [
  {
    text: t("Single Line"),
    id: "single-line",
    iconCss: "e-custom-fe-singleLineIcon",
    allowIn: [SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: true,
  },
  {
    text: t("Multi Line"),
    id: "multi-line",
    iconCss: "e-custom-fe-multiLineIcon",
    allowIn: [SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: true,
  },
  {
    text: t("Single Select"),
    id: "single-select",
    iconCss: "e-custom-fe-singleSelectIcon",
    allowIn: [SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: true,
  },
  {
    text: t("Multi Select"),
    id: "multi-select",
    iconCss: "e-custom-fe-checkBoxIcon",
    allowIn: [SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: true,
  },
  {
    text: t("Number"),
    id: "number",
    iconCss: "e-custom-fe-numberIcon",
    allowIn: [SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: true,
  },
  {
    text: t("Look Up"),
    id: "look-up",
    iconCss: "e-custom-fe-lookUpIcon",
    items: [
      { text: t("Location"), id: "Location" },
      { text: t("Teams"), id: "Teams" },
    ],
    notInModules: ["PROJECTS", "CONTRACT", "FILES", "ISSUES", "MODEL", "MAILBOX", "TRANSMITTAL"],
    allowIn: [SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: true,
  },
  {
    text: t("Date / Time"),
    id: "date-time",
    iconCss: "e-custom-fe-dateTimeIcon",
    allowIn: [SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: true,
  },
  {
    text: t("User(s)"),
    id: "users",
    iconCss: "e-custom-fe-userIcon",
    notInModules: ["PROJECTS", "CONTRACT", "FILES", "ISSUES", "MODEL", "MAILBOX", "TRANSMITTAL"],
    allowIn: [SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: false,
  },
  {
    text: t("File Upload"),
    id: "fileUpload",
    iconCss: "e-custom-fe-uploadIcon",
    notInModules: ["PROJECTS", "CONTRACT", "FILES", "ISSUES", "MODEL", "MAILBOX", "TRANSMITTAL"],
    allowIn: [SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: false,
  },
  {
    text: t("Image"),
    id: "image",
    iconCss: "e-custom-fe-imageIcon",
    notInModules: ["PROJECTS", "CONTRACT", "FILES", "ISSUES", "MODEL", "MAILBOX", "TRANSMITTAL"],
    allowIn: [SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: false,
  },
  {
    text: t("Geo Location"),
    id: "geoLocation",
    iconCss: "e-custom-fe-geoLocation",
    notInModules: ["PROJECTS", "CONTRACT", "FILES", "ISSUES", "MODEL", "MAILBOX", "TRANSMITTAL"],
    allowIn: [SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: false,
  },
  {
    text: t("Url"),
    id: "url",
    iconCss: "e-custom-fe-LinkIcon",
    notInModules: ["FILES", "MAILBOX"],
    allowIn: [SECTION_TYPE_TABLE_SECTION, SECTION_TYPE_BLANK_SECTION],
    allowPredifinedVal: true,
  },
];

const COMMON_SECTION_PROPS = [
  { text: t("Add Section To Library"), id: "add_to_section_library" },
  { text: t("Edit Section Title"), id: "edit_section_header" },
  { text: t("Delete Section"), id: "delete_section" },
];

export const getNormalSectionPropBtns = () => COMMON_SECTION_PROPS;

export const getPresetSectionPropBtns = () => [
  {
    text: t("Delete Section"),
    id: "delete_section",
  },
];
export const getTableSectionPropBtns = () => [
  ...COMMON_SECTION_PROPS,
  {
    text: t("Configure"),
    id: "configure",
  },
];

export const getSideBarMenuItems = () => [
  {
    text: t("Close Side Bar"),
    id: "closeSideBar",
  },
];

const getValidationValue = (allowAttachments) => {
  return [
    {
      name: t("Mandatory"),
      id: "isMandatory",
      allowIn: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_TABLE_SECTION],
    },
    ...(allowAttachments
      ? [
          {
            name: t("Require Attachment(s)"),
            id: "requireAttachments",
            allowIn: [SECTION_TYPE_BLANK_SECTION],
          },
        ]
      : []),
  ];
};

const COMMON_DETAIL_VALUE_VALIDATION = (allowAttachments = false) => [
  {
    name: t("Details"),
    id: "details",
    icon: "details",
  },
  {
    name: t("Value"),
    id: "value",
    icon: "ValueIcon",
  },
  {
    name: t("Validation"),
    id: "validation",
    icon: "ValidationIcon",
    values: getValidationValue(allowAttachments),
  },
];

export const getFormSideBarDataTemplate = (allowAttachments = false) => ({
  "single-select": COMMON_DETAIL_VALUE_VALIDATION(allowAttachments),
  "multi-select": COMMON_DETAIL_VALUE_VALIDATION(allowAttachments),
  "single-line": COMMON_DETAIL_VALUE_VALIDATION(allowAttachments),
  "multi-line": COMMON_DETAIL_VALUE_VALIDATION(allowAttachments),
  "date-time": COMMON_DETAIL_VALUE_VALIDATION(allowAttachments),
  fileUpload: COMMON_DETAIL_VALUE_VALIDATION(allowAttachments),
  image: COMMON_DETAIL_VALUE_VALIDATION(allowAttachments),
  geoLocation: COMMON_DETAIL_VALUE_VALIDATION(allowAttachments),
  url: [
    {
      name: t("Details"),
      id: "details",
      icon: "details",
    },
    {
      name: t("Validation"),
      id: "validation",
      icon: "ValidationIcon",
      values: getValidationValue(allowAttachments),
    },
  ],
  "look-up": [
    {
      name: t("Details"),
      id: "details",
      icon: "details",
    },
    {
      name: t("Validation"),
      id: "validation",
      icon: "ValidationIcon",
      values: getValidationValue(allowAttachments),
    },
  ],
  number: COMMON_DETAIL_VALUE_VALIDATION(allowAttachments),
  users: [
    {
      name: t("Details"),
      id: "details",
      icon: "details",
    },
    {
      name: t("Value"),
      id: "value",
      icon: "ValueIcon",
    },
    {
      name: t("Validation"),
      id: "validation",
      icon: "ValidationIcon",
      values: [
        {
          name: t("Mandatory"),
          id: "isMandatory",
          allowIn: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_TABLE_SECTION],
        },
        {
          name: t("Allow only current Logged in user"),
          id: "onlyCurrentUser",
          allowIn: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_TABLE_SECTION],
        },
        ...(allowAttachments
          ? [
              {
                name: t("Require Attachment(s)"),
                id: "requireAttachments",
                allowIn: [SECTION_TYPE_BLANK_SECTION],
              },
            ]
          : []),
      ],
    },
  ],
  actualStartDate: [
    {
      name: t("Value"),
      id: "value",
      icon: "ValueIcon",
    },
    {
      name: t("Validation"),
      id: "validation",
      icon: "ValidationIcon",
      values: [
        {
          name: t("Mandatory"),
          id: "isMandatory",
          allowIn: [SECTION_TYPE_TASK],
        },
      ],
    },
  ],
  actualEndDate: [
    {
      name: t("Value"),
      id: "value",
      icon: "ValueIcon",
    },
    {
      name: t("Validation"),
      id: "validation",
      icon: "ValidationIcon",
      values: [
        {
          name: t("Mandatory"),
          id: "isMandatory",
          allowIn: [SECTION_TYPE_TASK],
        },
      ],
    },
  ],
  progress: [
    {
      name: t("Validation"),
      id: "validation",
      icon: "ValidationIcon",
      values: [
        {
          name: t("Mandatory"),
          id: "isMandatory",
          allowIn: [SECTION_TYPE_TASK],
        },
      ],
    },
  ],
  remDuration: [
    {
      name: t("Validation"),
      id: "validation",
      icon: "ValidationIcon",
      values: [
        {
          name: t("Mandatory"),
          id: "isMandatory",
          allowIn: [SECTION_TYPE_TASK],
        },
      ],
    },
  ],
  tableSection: [
    {
      name: t("Validation"),
      id: "validation",
      icon: "ValidationIcon",
      values: [
        {
          name: t("Allow adding new rows during form filling"),
          id: "allowNewRowAddInForm",
          allowIn: [SECTION_TYPE_TABLE_SECTION],
        },
        {
          name: t("Predefine row values"),
          id: "allowPreDefineRowValues",
          allowIn: [SECTION_TYPE_TABLE_SECTION],
        },
        {
          name: t("Allow editing of predefined row values during form filling"),
          id: "allowEditPreDefineRowInForm",
          allowIn: [SECTION_TYPE_TABLE_SECTION],
        },
      ],
    },
  ],
});

export const templateEditCases = {
  EDIT_SECTION_HEADING: "editSectionHeading",
  DELETE_SECTION: "deleteSection",
  CHANGE_SECTION_SEQUENCE: "changeSectionSequence",
  CONFIGURE_SECTION: "configureSection",

  EDIT_QUESTION: "editQuestion",
  ADD_QUESTION: "addQuestion",
  DELETE_QUESTION: "deleteQuestion",
  CONFIGURE_QUESTION: "configureQuestion",
  CHANGE_QUESTION_SEQUENCE: "changeQuestionSequence",
};

export const lookUpType = ["Location", "Teams"];

export const fileTypesDataSource = [
  { name: "Pdf", value: "application/pdf" },
  { name: "Jpg", value: "image/jpg" },
  { name: "Png", value: "image/png" },
  { name: "Jpeg", value: "image/jpeg" },
];

export const imageTypesDataSource = [
  { name: "Jpg", value: "image/jpg" },
  { name: "Png", value: "image/png" },
  { name: "Jpeg", value: "image/jpeg" },
];

export const getIconFromFieldType = (fieldType) => {
  const iconName = fieldTypeToIconMap[fieldType];

  if (iconName) {
    return <IconComponent name={iconName} />;
  }
  return "";
};

export const getFieldTypeToHeadingMap = (t) => ({
  "single-line": t("Single Line"),
  "multi-line": t("Multi Line"),
  "single-select": t("Single Select"),
  "multi-select": t("Multi Select"),
  "date-time": t("Date / Time"),
  "look-up": t("Look Up"),
  "look-up-location": t("Look Up - Location"),
  "look-up-teams": t("Look Up - Teams"),
  number: t("Number"),
  users: t("User(s)"),
  fileUpload: t("File Upload"),
  image: t("Image"),
  url: t("Url"),
  geoLocation: t("Geo Location"),
  actualStartDate: t("Actual Start Date"),
  actualEndDate: t("Actual End Date"),
  progress: t("Progress %"),
  remDuration: t("Remaining Duration"),
});
